// @noflow
import Bar from './bar';
import PropTypes from 'prop-types';
import * as React from 'react';
const propTypes = {
    animDuration: PropTypes.number.isRequired,
    barChartData: PropTypes.arrayOf(
        PropTypes.shape({
            labelX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            width: PropTypes.number.isRequired,
            x: PropTypes.number.isRequired
        })
    ).isRequired,
    barColourMode: PropTypes.string.isRequired,
    barColours: PropTypes.array.isRequired,
    compHeight: PropTypes.number.isRequired,
    compWidth: PropTypes.number.isRequired,
    gutter: PropTypes.number.isRequired,
    handleMouseOut: PropTypes.func,
    handleMouseOver: PropTypes.func.isRequired,
    marginBottom: PropTypes.number.isRequired,
    xDomain: PropTypes.string.isRequired,
    yDomain: PropTypes.string.isRequired
};

const Bars = ({
    animDuration,
    barChartData,
    barColours,
    barColourMode,
    compWidth,
    compHeight,
    gutter,
    handleMouseOver,
    handleMouseOut,
    marginBottom,
    xDomain,
    yDomain
}) => {
    const barChartLength = barChartData.length;
    const actualBarChartLength = barChartData.reduce((total, item) => {
        return item[yDomain] !== 0 ? (total += 1) : total;
    }, 0);
    const bars = barChartLength
        ? barChartData.map((data, i) => {
              const yStart = compHeight - marginBottom;
              return (
                  <Bar
                      actualBarChartLength={actualBarChartLength}
                      animDuration={animDuration}
                      barChartLength={barChartLength}
                      barColourMode={barColourMode}
                      barColours={barColours}
                      compWidth={compWidth}
                      data={data}
                      gutter={gutter}
                      handleMouseOut={handleMouseOut}
                      handleMouseOver={handleMouseOver}
                      index={i}
                      key={`bar-${data.labelX}-${data[yDomain]}`}
                      xDomain={xDomain}
                      yDomain={yDomain}
                      yStart={yStart}
                  />
              );
          })
        : [<rect height="0" key="bar-0" width="0" x="0" y="0" />];
    return <svg name="BarGraphBars">{bars}</svg>;
};

Bars.propTypes = propTypes;

export default Bars;



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/graph/bars/index.js